import { onMounted, ref } from 'vue'
import { useToast } from 'primevue/usetoast'
import { toTypedSchema } from '@vee-validate/zod'
import { useFieldArray, useForm } from 'vee-validate'
import { supplierSchema } from '@/schemas/supplierSchema'
import { useRouter } from 'vue-router';
import { getSupplierById} from '@/api/suppliers';
import type { Supplier } from '@/types/supplier-types'
import { useSupplierStore } from '@/stores/supplier-store'
import{addressTypeData} from '@/constants/index'


export const useSupplierForm = (formType: 'add' | 'edit' | 'view'): any => {
  const { values, handleSubmit, errors, setErrors, resetForm, meta } = useForm({
    validationSchema: toTypedSchema(supplierSchema)
  })

  const {
    push: newAddress,
    remove: removeAddress,
    fields: addressFields
  } = useFieldArray('addresses')

  const supplierStore = useSupplierStore();
  const loading = ref(false)
  const toast = useToast()
  const router = useRouter()


  const showToast = (type: 'success' | 'error', title: string, message: string) => {
    toast.add({
      severity: type,
      summary: title,
      detail: message,
      life: 5000
    })
  }

  const getSupplierLocationAndCountry = (addresses: any) => {
    return addresses.map((address: any) => {
        const addressType = addressTypeData.find((addressType) => addressType.id === address.addressType)

        return { ...address, addressType }
    })
}

  onMounted(async () => {
    if (formType !== 'add') {
      const supplierId = router.currentRoute.value.params.id as string
      const supplier: Supplier = await getSupplierById(supplierId)

      if(supplier){
        const addresses =  getSupplierLocationAndCountry(supplier.addresses)
        resetForm({
          values: { ...supplier, addresses},
        })
        supplierStore.supplierPricings = supplier?.supplierPricings
      }
    }
  })

  return {
    values,
    errors,
    meta,
    handleSubmit,
    setErrors,
    addressFields,
    newAddress,
    removeAddress,
    showToast,
    loading,
    formType,
  }
}
